import { useState, useEffect } from 'react';
import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import SearchIcon from '@mui/icons-material/Search';
import DateRangeIcon from '@mui/icons-material/DateRange';
import Dropdown from 'react-bootstrap/Dropdown';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { callApi, ErrorAlert } from './utils';
import useApp from './../AppContext';
import { t } from './../i18n';
import './FieldSelector.css';
import "./../Components/QueryMaker.css";
import QueryMaker from './../Components/QueryMaker';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';



function ListQueryWizard(props) {
    const app = useApp();
    const [isOpen, setIsOpen] = useState(false);
    const [serverUrl] = useState(app.serverUrl);
    const [objectFields, setObjectFields] = useState(null);
    const [navQueue, setNavQueue] = useState([]);
    const [navPath, setNavPath] = useState(null);
    const [objectName, setObjectName] = useState(props.objectName);
    const [queryText, setQueryText] = useState(null);
    const [error, setError] = useState(null);
    const [showQueryMakerMenu, setShowQueryMakerMenu] = useState(false);
    const [menuAnchor, setMenuAnchor] = useState(null);
    const language = localStorage.getItem('preferredLanguage') || app.sessionToken?.Language;

    useEffect(() => {
        async function getLayout() {
            try {
                if (!objectName || !serverUrl) return;
                setError(null);
                let fields = await callApi('GET', `${serverUrl}/api/layouts/objectFields/${objectName}`, props.userToken);
                if (navPath) {
                    fields.forEach(f => f.columnName = navPath + "." + f.columnName)
                }
                setObjectFields(fields);
            } catch (err) {
                setError(err.message);
            }
        }
        getLayout();
    }, [navPath, objectName, props.userToken, serverUrl]);

    function onOpen() {
        setIsOpen(true);
        let queue = [{ objectName: props.objectName, objectCaption: props.objectCaption, navProp: "" }];
        setNavQueue(queue);
        setNavPath("");
        setObjectName(props.objectName);
        setQueryText(props.queryText);
    }

    function updateNavPath(queue) {
        let path = queue.map(p => p.navProp).join('.');
        if (path.startsWith('.')) {
            path = path.length === 1 ? '' : path.substr(1);
        }
        setNavPath(path);
    }

    function goBack(i) {
        if (i === navQueue.length - 1) return;
        let tmpQueue = [...navQueue];
        tmpQueue.splice(i + 1);
        setNavQueue(tmpQueue);
        setObjectName(tmpQueue[i].objectName);
        updateNavPath(tmpQueue);
    }

    function createBreadcrumb() {
        return (
            <div className="d-flex align-items-center justify-content-between">
                <Breadcrumb>
                    {navQueue.map((p, i) =>
                        <Breadcrumb.Item key={i} onClick={() => goBack(i)} style={{ paddingTop: "10px" }}>
                            {p.objectCaption}
                        </Breadcrumb.Item>
                    )}
                </Breadcrumb>
                <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => setQueryText('')}
                    className="query-wizard-btn query-wizard-btn-secondary"
                >
                    <DeleteForeverIcon />   {t('common.clear', language)}
                </Button>
            </div>
        );
    }

    function objectSelected(f) {
        let tmpQueue = [...navQueue, { objectName: f.refObject, objectCaption: f.caption, navProp: f.navProp }];
        setNavQueue(tmpQueue);
        setObjectName(f.refObject);
        updateNavPath(tmpQueue);
    }

    // function replaceDotsExceptFirst(str) {
    //     let firstDotIndex = str.indexOf('.');
    //     if (firstDotIndex === -1) return str;
    //     let beforeFirstDot = str.slice(0, firstDotIndex + 1);
    //     let afterFirstDot = str.slice(firstDotIndex + 1).replace(/\./g, '_');
    //     return beforeFirstDot + afterFirstDot;
    // }

    function appendField(field, operator) {
        if (operator === '') {
            const str = field.columnName;
            const firstDotIndex = str.indexOf('.');
            let processedName;
            if (firstDotIndex === -1) {
                processedName = (field.prefix ? field.prefix + '.' : '') + str;
            } else {
                const beforeFirstDot = str.slice(0, firstDotIndex + 1);
                const afterFirstDot = str.slice(firstDotIndex + 1).replace(/\./g, '_');
                processedName = beforeFirstDot + afterFirstDot;
            }
            setQueryText(prev => prev ? prev + ' {' + processedName + '}' : '{' + processedName + '}');
        } else {
            window.lastFieldToAppend = {
                field: {
                    ...field,
                    dataType: field.dataType || null
                },
                operator
            };
            setShowQueryMakerMenu(true);
        }
    }

    function createFieldList() {
        if (!objectFields) return null;
        return (
            <ListGroup className="field-list-group">
                {objectFields.map((f, i) =>
                    <ListGroup.Item key={i}>
                        <Form>
                            <Row style={{ position: 'relative', justifyContent: 'space-between' }}>
                                <div className="col-9 d-flex align-items-center">
                                    <div
                                        style={{
                                            width: '12px',
                                            height: '12px',
                                            borderRadius: '50%',
                                            marginRight: '8px',
                                            backgroundColor: f.refObject === null ? '#007bff' : '#ff9800'
                                        }}
                                    />
                                    {(f.refObject === null) ?
                                        <Form.Label className="mb-0">{f.caption}</Form.Label> :
                                        <Form.Label
                                            className="mb-0 field-link"
                                            as='a'
                                            onClick={() => objectSelected(f)}
                                        >{f.caption}</Form.Label>
                                    }
                                </div>
                                <div className="col-2" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const rect = e.currentTarget.getBoundingClientRect();
                                            setMenuAnchor({
                                                mouseX: rect.left - 185,
                                                mouseY: rect.top + 25,
                                                fieldIndex: i
                                            });
                                        }}
                                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                                    >
                                        <MoreHorizIcon style={{ fontSize: 22, color: '#888' }} />
                                    </button>
                                    <Menu
                                        open={!!menuAnchor && menuAnchor.fieldIndex === i}
                                        className='calendar-event-menu'
                                        onClose={() => setMenuAnchor(null)}
                                        anchorReference="anchorPosition"
                                        anchorPosition={menuAnchor ? { top: menuAnchor.mouseY, left: menuAnchor.mouseX } : undefined}
                                        sx={{
                                            '& .MuiMenu-paper': {
                                                transform: 'none !important',
                                                transition: 'opacity 267ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 178ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important'
                                            }
                                        }}
                                    >
                                        <MenuItem onClick={() => {
                                            appendField(f, '');
                                            setMenuAnchor(null);
                                        }}>
                                            <TextFieldsIcon sx={{ fontSize: 20, marginRight: 1, color: "var(--color-main-background)" }} />
                                            Append
                                        </MenuItem>
                                        <MenuItem onClick={() => {
                                            appendField(f, '=');
                                            setMenuAnchor(null);
                                        }}>
                                            <CompareArrowsIcon sx={{ fontSize: 20, marginRight: 1, color: "var(--color-main-background)" }} />
                                            Append as =
                                        </MenuItem>
                                        <MenuItem onClick={() => {
                                            appendField(f, 'LIKE');
                                            setMenuAnchor(null);
                                        }}>
                                            <SearchIcon sx={{ fontSize: 20, marginRight: 1, color: "var(--color-main-background)" }} />
                                            Append as LIKE
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                if (f.dataType === 'DateTime') {
                                                    appendField(f, 'DATE_RANGE');
                                                    setMenuAnchor(null);
                                                }
                                            }}
                                            disabled={f.dataType !== 'DateTime'}
                                        >
                                            <DateRangeIcon sx={{ fontSize: 20, marginRight: 1, color: "var(--color-main-background)" }} />
                                            Append as Date Range
                                        </MenuItem>
                                    </Menu>
                                </div>
                            </Row>
                        </Form>
                    </ListGroup.Item>
                )
                }
            </ListGroup >
        );
    }

    async function apply() {
        try {
            setError(null);
            let url = `${serverUrl}/api/layouts/list/${props.layoutId}`;
            if (props.instanceName) url += `?instanceName=${props.instanceName}`;
            await callApi('POST', url, props.userToken, { queryText });

            if (props.onQueryChange) {
                props.onQueryChange(); 
            }
            
            if (props.querySaved) props.querySaved();
            setIsOpen(false);
        } catch (err) {
            setError(err.message);
        }
    }

    function createModal() {
        if (!isOpen) return null;
        return (
            <Modal
                show={isOpen}
                onHide={() => setIsOpen(false)}
                backdrop="static"
                size='lg'
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t('toolkit.filterExpression', language)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorAlert message={error} setMessage={setError} language={language}/>
                    {createBreadcrumb()}
                    <Row>
                        <Col sm={6}>{createFieldList()}</Col>
                        <Col sm={6}>
                            <QueryMaker
                                queryText={queryText}
                                setQueryText={setQueryText}
                                language={language}
                                showContextMenu={showQueryMakerMenu}
                                setShowContextMenu={setShowQueryMakerMenu}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={apply} className="query-wizard-btn query-wizard-btn-primary">
                        {t('common.apply', language)}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    return (
        <>
            <Dropdown.Item className="btn-sm" onClick={onOpen}>
                {t('toolkit.filterDesigner', language)}
            </Dropdown.Item>
            {createModal()}
        </>
    );
}

export default ListQueryWizard;
